import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Unreleased = () => {
    return (
        <div style={{ height: 'calc(100vh - (8 * var(--template-spacing)) - 40px)', marginTop: '0', overflow: 'hidden' }}>
            <DotLottieReact
                src="/assets/lottie/dev.lottie"
                loop
                autoplay
                style={{ width: '220%', marginLeft: '-55%' }}
            />
        </div>
    );
};

export default Unreleased;